import { Controller } from "@hotwired/stimulus";

/** Enables the submit button in the Salary Matrix modal when the terms checkbox is checked. */
export default class extends Controller {
  static targets = ["checkbox", "submit"];

  connect() {
    this.toggleDisabled();
  }

  toggleDisabled() {
    if (!this.hasSubmitTarget || !this.hasCheckboxTarget) return;

    this.submitTarget.disabled = !this.checkboxTarget.checked;
  }
}
